var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowRight2020 = function SvgIconArrowRight2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M6.875 16.506a.833.833 0 0 1 0-1.179l4.827-4.827-4.827-4.827a.833.833 0 1 1 1.178-1.179l4.828 4.827c.65.651.65 1.707 0 2.358l-4.828 4.827a.833.833 0 0 1-1.178 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconArrowRight2020;